import { CauseAndActionSection } from './FixedAssetsDiagnosticsOverview';
import { Skeleton } from '@/components/ui/skeleton';

interface CauseAndActionProps {
  assetName: string;
  components: any[];
  diagnostics: any[];
  isLoading: boolean;
}

export const AssetOverview = ({ assetName, components, isLoading }: CauseAndActionProps) => {
  return isLoading ? (
    <Skeleton className="h-full" />
  ) : (
    <CauseAndActionSection
      assetName={assetName}
      setViewType={() => {}}
      components={components}
      isLoading={isLoading}
    />
  );
};
